import axios from "axios";
import React, { useState } from 'react'
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from '@mui/material';
import joinActivityImg from '../assets/undraw_join_re_w1lh.svg';
import url from '../url.js';

export const JoinActivityForm = ({ callback_setActivities }) => {
    const userId = localStorage.getItem('userId'); 
    const [open, setOpen] = React.useState(false);
    const [data, setData] = useState({
        userId: userId,
        joinCode: ""
    });
    const [activityData, setActivityData] = useState({
        ActivityGroup:{
            Activity: {
                createdAt: '',
                endDate: '',
                title: ''
            },
            Group: {
                groupName: ''
            }
        }
    })
    
    const handleClickOpen = () => {
        setOpen(true);
    };
  
    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setData({
            ...data,
            [e.target.name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const jwtToken = localStorage.getItem('jwtToken');
        const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};
        const activityData = {
            userId: data.userId,
        };
        axios
            .put(`${url.backendHost}api/groups/${data.joinCode}/join`, activityData, { headers, withCredentials: true })
            .then((groupRes) => {

                axios.get(`${url.backendHost}api/activities/myJoined/${data.userId}`, { headers, withCredentials: true }).then((fetchData)=>{
                    callback_setActivities(fetchData.data);
                    
                    setOpen(false);
                    setData({
                        userId: userId,
                        joinCode: ""
                    });

                    // renew token
                    axios.get(`${url.backendHost}api/users/renew`, { headers, withCredentials: true })
                    
                    // 
                    alert("成功加入活動!");
                    window.location.reload();
                    
                  }).catch((error) => {
                        alert("取得活動失敗...");
                        
                  })
            })
            .catch((error) => {
                alert("加入活動失敗 請確認邀請碼!");
                if (error.response) {
                    // 
                    // 
                } else if (error.request) {
                    // 
                } else {
                    // 
                }
            });
    };
  
    return (
      <div>
        <>  
            <div onClick={handleClickOpen}>
                探索更多活動
            </div>
        </>
        <Dialog open={open} onClose={handleClose}>
            <div>
              <img className='modal-image' src={joinActivityImg} />
            </div>
            <DialogTitle>加入探究活動</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="title"
                    label={"請輸入小組邀請碼"}
                    type="text"
                    name='joinCode'
                    value={data.joinCode}
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions>
                <Button type='submit' onClick={handleSubmit}>加入</Button>
            </DialogActions>
        </Dialog>
      </div>
    );
}